<template>
  <div class="w-100 ">

    <m-card-516 class="img-card-a"
                :image="product.thumbnail"
                :alt="product.name"
                :image-link="{ name: 'Product', params: { name: product.raw_link } }">

      <div class="card-body text-center">

        <a class="card-text font-size-dynamic-h5 font-weight-bold text-dark text-decoration-none"
           href="">{{ product.name }}</a>

      </div>
      <div>
        <span v-if="product.rate_count > 0"><i class="bi bi-star-fill text-warning star"></i></span>
        <span v-if="product.rate_count > 0" class=" px-2 font-size-dynamic-h6 text-dark">{{ product.rate_count }}</span>
        <span class="font-size-dynamic-h7 custom-text-color d-none">(10 نظر)</span>
      </div>

      <div class="text-left">
        <m-product-price500 class="px-2 font-weight-bold d-inline" :product="product"/>

      </div>

      <div class=" row">
        <m-a class="text-center buy-button col-12" :href="{ name: 'Product', params: { name: product.raw_link } }">
          <h6 class="bg-warning text-dark  buy-button-content my-2 shadow-sm font-weight-bold "> خرید</h6>
        </m-a>

      </div>

    </m-card-516>
  </div>

</template>

<script>
import {mapGetters} from "vuex";
import mCard516 from "../../Cards/Card516";
import mProductCardQuantityManager1 from "../../Product/QuantityManager/Card/ProductCardQuantityManager1";
import mProductPrice500 from "../../Product/ProductPrice500";
import mA from '../../Tags/A'
import mIcon from '../../Icons/Icon.vue'
import mProductOffer1 from "../../Product/ProductOffer/ProductOffer1";
import {OfferProps} from '../ProductOffer/ProductOfferProps'
import {shoppingCartFunctions} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {
  addFeatureToProduct,
  featureCategories, findFeatureWithSelectedName, groupByType, productFeatureValue,
  removeChildFeature, removeEmptyGroups, sortedFeaturesMethod
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import mDelete1 from "../../Tool/Delete/Delete1.vue";

export default {
  name: "ProductCard450",
  components: {mCard516, mDelete1, mProductCardQuantityManager1, mA, mProductPrice500, mProductOffer1, mIcon},
  props: {
    product: {},
    productCardLink: {
      default: '_self',
    },
    inActiveQuantityManager: {
      type: Boolean,
      default: true
    },
    showKeywords: {
      type: Boolean,
      default: false
    },
    OfferProps
  },
  computed: {
    ...mapGetters({
      profile: "User/getProfile"
    }),
    productFeatures() {
      return this.product.feature_product
    },
    publishStatus() {
      return this.product.status == 0 ? false : true
    },
    publishStatusText() {
      if (this.publishStatus) { // published true
        return this.$t('filter.product_status.publish')
      }
      return this.$t('filter.product_status.draft')
    },
    accessToAdminFeatures() {
      return [1, 2].indexOf(this.profile.role) > -1
    }
  },
  methods: {
    dateConverter,
    addFeatureToProduct,
    featureCategories,
    groupByType,
    removeChildFeature,
    removeEmptyGroups,
    sortedFeaturesMethod,
    productFeatureValue,
    findFeatureWithSelectedName,
    ...shoppingCartFunctions,

  },

}
</script>

<style scoped>
.buy-button-content {
  border-radius: 12px;
  padding: 12px;
}

.buy-button {
  position: absolute;
  bottom: 13px;
  width: 80%;
  translate: -10px;


}

.img-card-a {
  border-radius: 15px;
}

.star {
  font-size: 12px;

}


.custom-text-color {
  color: rgb(129, 129, 129);
}

.font-size-dynamic-h7 {
  font-size: clamp(5px, 5vw, 10px);

}

.font-size-dynamic-h6 {

  font-size: clamp(7px, 5vw, 13px);

}

.font-size-dynamic-h5 {


  font-size: calc(0.5rem + 0.7vw);

}


</style>